import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EAPImportDialog from '../components/EAPImportDialog';
import NavigationHistory from '../components/NavigationHistory';
import BreadcrumbNavigation from '../components/BreadcrumbNavigation';

const MainLayout: React.FC = () => {
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const userEmail = localStorage.getItem('user_email');

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_email');
    navigate('/login');
  };

  const handleImportEAP = () => {
    setIsImportDialogOpen(true);
  };

  const handleImportSuccess = () => {
    console.log('Import completed successfully');
    // Refresh current page data if needed
  };

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  return (
    <div style={{ padding: 20 }}>
      <nav style={{ marginBottom: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
        <NavigationHistory />
        <Link 
          to="/plans" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/plans') ? 'bold' : 'normal',
            color: isActive('/plans') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.plans')}
        </Link>
        <Link 
          to="/partners" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/partners') ? 'bold' : 'normal',
            color: isActive('/partners') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.partners')}
        </Link>
        <Link 
          to="/programs" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/programs') ? 'bold' : 'normal',
            color: isActive('/programs') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.programs')}
        </Link>
        <Link 
          to="/chains" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/chains') ? 'bold' : 'normal',
            color: isActive('/chains') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.chains')}
        </Link>
        <Link 
          to="/stores" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/stores') ? 'bold' : 'normal',
            color: isActive('/stores') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.stores')}
        </Link>
        <Link 
          to="/workers" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/workers') ? 'bold' : 'normal',
            color: isActive('/workers') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.workers')}
        </Link>
        <Link 
          to="/business-types" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/business-types') ? 'bold' : 'normal',
            color: isActive('/business-types') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.businessTypes')}
        </Link>
        <Link 
          to="/optimization-tasks" 
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/optimization-tasks') ? 'bold' : 'normal',
            color: isActive('/optimization-tasks') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.tasks')}
        </Link>
        <Link 
          to="/profile"
          style={{ 
            marginRight: 16,
            fontWeight: isActive('/profile') ? 'bold' : 'normal',
            color: isActive('/profile') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.profile')}
        </Link>
        <Link 
          to="/settings"
          style={{ 
            fontWeight: isActive('/settings') ? 'bold' : 'normal',
            color: isActive('/settings') ? '#1976d2' : 'inherit'
          }}
        >
          {t('navigation.settings')}
        </Link>
        <span style={{ flex: 1 }} />
        <button 
          onClick={handleImportEAP}
          style={{
            padding: '8px 16px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#4caf50',
            color: 'white',
            cursor: 'pointer',
            marginRight: 16
          }}
        >
          📥 {t('auth.importEAP')}
        </button>
        {userEmail && <span style={{ marginRight: 16 }}>{t('auth.signedInAs')} <b>{userEmail}</b></span>}
        <button onClick={handleLogout}>{t('auth.logout')}</button>
      </nav>
      
      <BreadcrumbNavigation />
      
      <Outlet />
      
      <EAPImportDialog 
        isOpen={isImportDialogOpen}
        onClose={() => setIsImportDialogOpen(false)}
        onImportSuccess={handleImportSuccess}
      />
    </div>
  );
};

export default MainLayout;